var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getImageSize(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onabort = () => {
                reject(new Error('Image loading aborted'));
            };
            image.onload = () => {
                resolve({
                    width: image.width,
                    height: image.height
                });
            };
            image.src = URL.createObjectURL(file);
        });
    });
}
export function convertFileToBase64(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => {
                var _a, _b;
                resolve((_b = (_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '');
            };
            reader.readAsDataURL(file);
        });
    });
}
export function savePDF(fileName, base64Content) {
    const linkSource = `data:application/pdf;base64,${base64Content}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmlsZVV0aWwuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsidXRpbC9maWxlVXRpbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFFQSxNQUFNLFVBQWdCLFlBQVksQ0FBRSxJQUFVOztRQUM1QyxPQUFPLElBQUksT0FBTyxDQUNoQixDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRTtZQUNsQixNQUFNLEtBQUssR0FBRyxJQUFJLEtBQUssRUFBRSxDQUFBO1lBQ3pCLEtBQUssQ0FBQyxPQUFPLEdBQUcsR0FBRyxFQUFFO2dCQUNuQixNQUFNLENBQUMsSUFBSSxLQUFLLENBQUMsdUJBQXVCLENBQUMsQ0FBQyxDQUFBO1lBQzVDLENBQUMsQ0FBQTtZQUNELEtBQUssQ0FBQyxNQUFNLEdBQUcsR0FBRyxFQUFFO2dCQUNsQixPQUFPLENBQUM7b0JBQ04sS0FBSyxFQUFFLEtBQUssQ0FBQyxLQUFLO29CQUNsQixNQUFNLEVBQUUsS0FBSyxDQUFDLE1BQU07aUJBQ3JCLENBQUMsQ0FBQTtZQUNKLENBQUMsQ0FBQTtZQUNELEtBQUssQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQTtRQUN2QyxDQUFDLENBQ0YsQ0FBQTtJQUNILENBQUM7Q0FBQTtBQUVELE1BQU0sVUFBZ0IsbUJBQW1CLENBQUUsSUFBVTs7UUFDbkQsT0FBTyxJQUFJLE9BQU8sQ0FDaEIsT0FBTyxDQUFDLEVBQUU7WUFDUixNQUFNLE1BQU0sR0FBRyxJQUFJLFVBQVUsRUFBRSxDQUFBO1lBQy9CLE1BQU0sQ0FBQyxTQUFTLEdBQUcsR0FBRyxFQUFFOztnQkFDdEIsT0FBTyxDQUFDLE1BQUEsTUFBQSxNQUFNLENBQUMsTUFBTSwwQ0FBRSxRQUFRLEVBQUUsbUNBQUksRUFBRSxDQUFDLENBQUE7WUFDMUMsQ0FBQyxDQUFBO1lBQ0QsTUFBTSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQTtRQUM1QixDQUFDLENBQ0YsQ0FBQTtJQUNILENBQUM7Q0FBQTtBQUVELE1BQU0sVUFBVSxPQUFPLENBQUUsUUFBZ0IsRUFBRSxhQUFxQjtJQUM5RCxNQUFNLFVBQVUsR0FBRywrQkFBK0IsYUFBYSxFQUFFLENBQUE7SUFDakUsTUFBTSxZQUFZLEdBQUcsUUFBUSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUNoRCxZQUFZLENBQUMsSUFBSSxHQUFHLFVBQVUsQ0FBQTtJQUM5QixZQUFZLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQTtJQUNoQyxZQUFZLENBQUMsS0FBSyxFQUFFLENBQUE7QUFDdEIsQ0FBQyJ9